import React, { useEffect, useRef, useState } from "react"
import { useLocation } from '@reach/router'
import { useTheme }  from '~/contexts/ThemeContext'
import { notBlank, jnstyls } from '~/utils/helpers'

import HomeImg from './home-img'
import { Title, Subtitle, Ctas, Body } from './contents'

import * as styles from "~/styles/home/two-images.module.scss"


const TwoImages = ({ block, index }) => {
  const location = useLocation()
  const { gender } = useTheme()

  const { type, is_main, images } = block

  const [isPreview, setIsPreview] = useState(false)
  const twoImgRef = useRef(null)

  let styles_arr = [type === 'two_img' ? styles.twoeq : styles.twooff, 'nd_twooff']
  if (block.first) styles_arr.push(styles.first)

  const check_show = (image) => {
    if (!isPreview) {
      return gender === block.gender && notBlank(image.image)
    }
    return notBlank(image.image)
  }

  useEffect(() => {
    if (location.pathname.includes('/preview/')) setIsPreview(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div 
      className={styles_arr.join(' ')} 
      mok-block={index}
      g={block.gender} 
      ref={twoImgRef}
      mid={block.id}
    >
      {images.map((image, imgIndex) => {
        const img_size = image.size.includes('%') ? image.size : `${image.size}%`
        const img_mobile = !!image.show_mobile
        const imgmob_class = img_mobile ? '' : styles.nomob
        const size_class = img_size !== '100%' ? styles.smaller : ''

        let capt 
        let capt_desk = '' 
        let captcont = image.captions && image.captions.length > 0 && image.captions[0].contents.length > 0
        if ( img_mobile && !captcont ) {
          if ( images.find( img => img !== image) ) { 
            capt = images.find( img => img !== image).captions[0]
            capt_desk = styles.nodesk
          } 
        } else if ( image.hasOwnProperty('captions') && image.captions.length ) {
          capt = image.captions[0]
        }
        const captmob_class = capt && !!capt.show_mobile ? '' : styles.nomob
        let captalign_class = capt && capt.align === 'right' ? styles.capt_aright : ''
        if (capt && capt.align === 'center') captalign_class = styles.capt_acenter

        return (
          <div 
            key={`twoimg${index}-${imgIndex}`} 
            className={jnstyls([is_main ? '' : '', styles.item, imgmob_class, size_class])} 
          >
            {check_show(image) && (
              <HomeImg item={image} show_mobile={img_mobile} index={index} block={block} />
            )}
            {(!!capt && capt.contents) && (
              <div className={jnstyls([styles.caption, capt_desk, captmob_class, captalign_class])}>
                {capt.contents.map((content, contIndex) => {
                  switch (content.type) {
                    case 'title':
                      return (
                        <Title 
                          key={`twoimgcapt${index}-${contIndex}`}
                          block={block} 
                          from={'from_two'} 
                          item={content} 
                          index={index} 
                          pstyles={styles} 
                        />
                      )
                    case 'subtitle':
                      return (
                        <Subtitle 
                          key={`twoimgcapt${index}-${contIndex}`} 
                          block={block} 
                          from={'from_two'} 
                          item={content} 
                          index={index} 
                          pstyles={styles} 
                        />
                      )
                    case 'body':
                      return (
                        <Body 
                          key={`twoimgcapt${index}-${contIndex}`} 
                          block={block} 
                          from={'from_two'} 
                          copy={content.copy} 
                          index={index} 
                          pstyles={styles} 
                        />
                      )
                    case 'cta':
                      return (
                        <Ctas 
                          key={`twoimgcapt${index}-${contIndex}`} 
                          block={block} 
                          from={'from_two'} 
                          item={content} 
                          index={index} 
                          pstyles={styles} 
                        />
                      )
                    default:
                      return <React.Fragment key={`twoimgcapt${index}-${contIndex}`} />
                  }
                })}
              </div>
            )}
          </div>
        )
      })}

    </div>
  )
}

export default TwoImages




